import { Component, Input } from "@angular/core";
import { AbstractControl, UntypedFormGroup } from "@angular/forms";
import { DateTime } from "luxon";
import { TypeCustomFields } from "src/app/shared/enums/type-custom-fields";
import { TypeModule } from "src/app/shared/enums/type-module";
import { IFullCustomField } from "src/app/shared/interfaces/custom-fields.interfaces";
import { FormsService, LuxonService } from "src/app/shared/services";

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: "cf-form-visual-error",
	templateUrl: "./cf-form-visual-error.component.html",
	styleUrls: ["./cf-form-visual-error.component.scss"],
	standalone: false
})
export class FormVisualErrorComponent {
	@Input() computedCustomField: IFullCustomField;
	@Input() form: UntypedFormGroup | AbstractControl;
	@Input() language: string;
	@Input() mode: "singleLanguage" | "multiLanguage";

	typeCustomFields = TypeCustomFields;
	typeModule = TypeModule;
	dateTime = DateTime;

	constructor(
		public SForm: FormsService,
		public SLuxon: LuxonService
	) {}
}
